import {Injectable} from '@angular/core';
import {RequestProvider} from "../request/request";

/*
  Generated class for the SaleOrderProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SaleOrderProvider {

  constructor(public request: RequestProvider) {
  }

  search(term: string) {
    return new Promise((resolve, reject) => {
      this.request.get(`sale.order/search/${term}`, true).subscribe(data => {
        if (data.count == 0) resolve([]);
        else resolve(data.results);
      }, err => {
        resolve([]);
      });
    });
  }

  get(name: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`sale.order/${name}`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve({});
      });
    });
  }

  getConfirmed(name: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`sale.order/${name}/is-confirmed`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve({});
      });
    });
  }

  confirm(name: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`sale.order/${name}/confirm`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve({});
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/sale-order/sale-order.ts